import { render, staticRenderFns } from "./ObjectDetailMapBasic.vue?vue&type=template&id=d532c3ba&scoped=true"
import script from "./ObjectDetailMapBasic.vue?vue&type=script&lang=js"
export * from "./ObjectDetailMapBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d532c3ba",
  null
  
)

export default component.exports